import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { DataTableStatic } from 'components/organisms'
import { processedItemTableColumns } from 'domains/seller-inventory-batch/molecules/item-table-columns'


const proptypes = {
  data           : PropTypes.array,
  isLoading      : PropTypes.bool,
  rowButtonProps : PropTypes.shape({
    buttonText       : PropTypes.string,
    buttonColour     : PropTypes.string,
    isButtonDisabled : PropTypes.func,
    onButtonClick    : PropTypes.func
  }),
  hiddenColumns: PropTypes.array
}

const defaultProps = {
  rowButtonProps: {
    buttonText       : '',
    buttonColour     : '',
    isButtonDisabled : () => {},
    onButtonClick    : () => {}
  }
}


/**
 * Domain-specifc StaticDataTable for Seller Inventory Batch Item
 * @param {object[]} data - array of seller_inbound_inventory_batch_item objects
 * @param {object} pagination - object of pagination data from endpoint
 * @param {bool} isLoading - whether the table is currently loading data from the backend
 * @param {object} rowButtonProps - Button Props for row button
 * @param {array} hiddenColumns - Hide specific columns by id
 */
const SellerInventoryBatchProcessedItemTable = ({
  data,
  isLoading,
  rowButtonProps,
  hiddenColumns
}) => {

  /**
   * It's important that we're using React.useMemo
   * here to ensure that our data isn't recreated on every render.
   * see https://react-table.tanstack.com/docs/quick-start
   *
   * we destruct rowButtonProps to make sure this object only render once
   *  */
  const { buttonText, buttonColour, isButtonDisabled, onButtonClick } = rowButtonProps

  const columns = useMemo(
    () => processedItemTableColumns({
      buttonText,
      buttonColour,
      isButtonDisabled,
      onButtonClick
    }),
    [
      buttonText,
      buttonColour,
      isButtonDisabled,
      onButtonClick
    ]
  )

  return (
    <DataTableStatic
      data={ data }
      columns={ columns }
      isLoading= { isLoading }
      hiddenColumns={ hiddenColumns }
    />
  )
}

SellerInventoryBatchProcessedItemTable.propTypes    = proptypes
SellerInventoryBatchProcessedItemTable.defaultProps = defaultProps

export default SellerInventoryBatchProcessedItemTable
